document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-add-to-cart]');
      if (!button) return;
      if (button.classList.contains('is-loading')) return;
      const form = button.closest('[data-product-form]');
      const variantInput = form.querySelector('[data-variant-id]');

      const variantId = variantInput.value;

      button.classList.add('is-loading');

      const buttonText = button.querySelector('.product-card__button-text');
      const originalText = buttonText.textContent;

      buttonText.textContent = 'Adding...';

      try {

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        buttonText.textContent = 'Added';

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: cart,
            bubbles: true
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:item-added', {
            detail: cart
          })
        );

        const sideCart = document.getElementById('side-cart');

        if (sideCart && typeof sideCart.toggleCart === 'function') {

          setTimeout(() => {
            sideCart.toggleCart();
          }, 300);

        } else if (sideCart) {

          setTimeout(() => {

            sideCart.classList.add('active');

            let overlay = document.getElementById('cart-overlay');

            if (!overlay) {
              overlay = document.createElement('div');
              overlay.id = 'cart-overlay';
              overlay.className = 'cart-overlay';
              document.body.appendChild(overlay);
            }

            overlay.classList.add('active');
            document.body.classList.add('no-scroll');

          }, 300);

        }

        setTimeout(() => {
          buttonText.textContent = originalText;
        }, 2000);

      } catch (error) {

        console.error(error);

        buttonText.textContent = 'Error';

        setTimeout(() => {
          buttonText.textContent = originalText;
        }, 2000);

      } finally {

        button.classList.remove('is-loading');

      }

    });

    document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-load-more");
    if (!btn) return;

    const url = btn.dataset.nextUrl + "&view=ajax";

    btn.disabled = true;
    btn.classList.add("loading");

    try {
      const res = await fetch(url);
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, "text/html");

      const products = doc.querySelectorAll(".js-ajax-product");
      const grid = document.querySelector(".js-load-more-grid");

      if (!grid) return;

      products.forEach((p) => grid.appendChild(p));
      initBazaarvoiceReviewThreshold();

      const newBtn = doc.querySelector(".js-load-more");

      if (newBtn) {
         btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.classList.remove("loading");
      } else {
        btn.remove();
      }

    } catch (err) {
      console.error("Load More Error:", err);
      btn.disabled = false;
      btn.classList.remove("loading");
    }
  });
  function initBazaarvoiceReviewThreshold() {
    document.querySelectorAll(".product-card__rating").forEach((rating) => {

        if (rating.dataset.bvObserved) return;
        rating.dataset.bvObserved = "true";

        const observer = new MutationObserver(() => {

            const reviewMeta = rating.querySelector(
                'meta[itemprop="reviewCount"]'
            );

            if (!reviewMeta) return;

            const reviewCount = Number(reviewMeta.content);

            if (reviewCount > 50) {

                rating.style.display = "block";

                const widget = rating.querySelector(".bv-inline-rating");

                if (widget) {
                    widget.style.visibility = "visible";
                }
            }

            observer.disconnect();

        });

        observer.observe(rating,{
            childList:true,
            subtree:true
        });

    });
  }
  initBazaarvoiceReviewThreshold();
});
